module.exports = __webpack_public_path__ + "assets/000e562323c8a41a90010c4d8ceb85d4.mp3";